import React from 'react';
import styled from 'styled-components';
import { FolderOpen } from 'lucide-react';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4rem 2rem;
  min-height: 400px;
`;

const Icon = styled.div`
  margin-bottom: 1.5rem;
  color: var(--text-muted);

  svg {
    width: 3rem;
    height: 3rem;
    stroke-width: 1.5;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.75rem 0;
`;

const Description = styled.p`
  font-size: 1rem;
  color: var(--text-secondary);
  max-width: 420px;
  line-height: 1.6;
  margin: 0 0 2rem 0;
`;

const UploadHint = styled.p`
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0;
`;

export const SmartSortingEmptyState: React.FC = () => {
  return (
    <Container>
      <Icon aria-hidden>
        <FolderOpen />
      </Icon>
      <Title>Clasificación Inteligente</Title>
      <Description>
        Sube documentos y los clasificaremos automáticamente en categorías
        usando inteligencia artificial. Arrastra archivos o usa el botón para
        comenzar.
      </Description>
      <UploadHint>
        Formatos soportados: PDF, JPG, PNG, TXT, CSV — Máximo 10 MB
      </UploadHint>
    </Container>
  );
};
